import React, { useContext, useState, useMemo, useCallback, useEffect } from "react";
import { getCachedRowsPerPage, setCachedRowsPerPage } from "../utils/persistentCache";

const OffersContext = React.createContext();

export function useOffers() {
  return useContext(OffersContext);
}

export function OffersProvider({ children }) {
  const [allOffers, setAllOffers] = useState([]);
  const [loading, setLoading] = useState(true); // 初始为 true，等待首次加载
  const [searchFilters, setSearchFilters] = useState({});
  const [page, setPage] = useState(0);
  // 从缓存读取每页条数，如果没有缓存则默认25
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const cached = getCachedRowsPerPage();
    return cached || 25;
  });
  const [isInitialLoad, setIsInitialLoad] = useState(true); // 标记是否需要初始加载

  // 当 rowsPerPage 变化时，保存到缓存
  useEffect(() => {
    setCachedRowsPerPage(rowsPerPage);
  }, [rowsPerPage]);

  // 优化：使用 useCallback 包装 setter 函数，避免不必要的重新渲染
  const handleSetAllOffers = useCallback((offers) => {
    setAllOffers(offers);
  }, []);

  const handleSetSearchFilters = useCallback((filters) => {
    setSearchFilters(filters);
  }, []);

  const handleSetPage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handleSetRowsPerPage = useCallback((newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  }, []);

  // 优化：使用 useMemo 缓存 context value，避免不必要的重新渲染
  const value = useMemo(
    () => ({
    allOffers,
      setAllOffers: handleSetAllOffers,
    loading,
    setLoading,
    searchFilters,
      setSearchFilters: handleSetSearchFilters,
    page,
      setPage: handleSetPage,
    rowsPerPage,
      setRowsPerPage: handleSetRowsPerPage,
    isInitialLoad,
    setIsInitialLoad,
    }),
    [
      allOffers,
      handleSetAllOffers,
      loading,
      searchFilters,
      handleSetSearchFilters,
      page,
      handleSetPage,
      rowsPerPage,
      handleSetRowsPerPage,
      isInitialLoad,
    ]
  );

  return (
    <OffersContext.Provider value={value}>{children}</OffersContext.Provider>
  );
}
